import { getPageQuery } from '@/utils/utils'
const translateMap = {
  CONTINUE_READING: {
    en: 'CONTINUE READING',
    in: 'LANJUT MEMBACA',
    ja: '続きを読む',
    ko: '계속 읽기',
    tw: '繼續閱讀',
    es: 'Sigue Leyendo',
    pt: 'Continuar lendo'
  },
  CLICK_TO_READ: {
    en: 'Click to read more exciting content',
    in: 'Klik untuk membaca konten menarik lainnya',
    ja: 'さらに興味深いコンテンツを読むにはクリック',
    ko: '더 흥미로운 콘텐츠를 보려면 클릭하세요',
    tw: '點擊閱讀更多精彩內容',
    es: 'Haz clic para leer más',
    pt: 'Clique para ler mais conteúdo emocionante'
  }
}

export const i18n = (key: string, ...args: string[]): string => {
  const { lang = 'en' } = getPageQuery()
  // @ts-ignore
  let translatedText = translateMap[key][lang] || translateMap[key]['en']

  // 替换特殊表示符 $1, $2, ...
  args.forEach((arg, index) => {
    const placeholder = `$${index + 1}`
    translatedText = translatedText?.replace(placeholder, arg)
  })

  return translatedText
}
